/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import { Typography } from '@material-ui/core';
import { formatMoneyWithPrefix } from 'app/utils/formatMoneyWithPrefix';
import {
  totalcss,
  backbuttoncss,
} from 'app/components/Charts/sunburst/common/innervizstat/styles';

interface InnerVizStatProps {
  count: number;
  goBack: Function;
  showGoBackBtn: boolean;
}

export function InnerVizStat(props: InnerVizStatProps) {
  return (
    <div css={totalcss}>
      <Typography
        variant="h3"
        id="sunburst-stat"
        color="textPrimary"
        css={`
          font-weight: 700;
          margin-bottom: 10px;
          color: ${props.count === 0 ? 'rgba(61, 61, 61, 0.6)' : ''};
          @media (max-width: 767px) {
            font-size: 20px;
          }
          font-size: ${props.count === 0 ? '16px' : '34px'};
        `}
      >
        {props.count === 0 ? 'Not available' : formatMoneyWithPrefix(props.count)}
      </Typography>
      {props.showGoBackBtn && (
        <div css={backbuttoncss} onClick={() => props.goBack()}>
          Back
        </div>
      )}
    </div>
  );
}
